import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  volunteer: {},
  exp: -1,
  login: null,
  volunteerLoadStatus: 0,
  list: [],
  states_volunteer: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: -1 },
  current_filters: {},
  rel_event_entity_list: [],
  event_confirmed_list: []
};

// getters
const getters = {
  getSession(state) {
    return { volunteer: state.volunteer, exp: state.exp, login: state.login };
  },
  /*
        Returns the volunteer load status.
    */
  getVolunteerLoadStatus(state) {
    return function () {
      return state.volunteerLoadStatus;
    };
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getVolunteer(state) {
    return state.volunteer;
  },

  getList: (state) => (id) => {
    var aVolunteers = [];
    for (var i in state.list) {
      if (state.list[i].visible) aVolunteers.push(state.list[i]);
    }
    return aVolunteers;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aVolunteers = [];
    for (var i in state.list) {
      aVolunteers.push(state.list[i]);
    }
    return aVolunteers;
  },

  get_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.list[id] !== "undefined") {
      var volunteer = state.list[id];
      return volunteer;
    }
    return false;
  },

  getStatesVolunteer: (state, getter, rootState) => (params) => {
    return state.state_volunteer;
  },

  getRelEventEntityList: (state, getters, rootState) => () => {
    return state.rel_event_entity_list;
  },

  getEventConfirmedList: (state) => {
    return state.event_confirmed_list;
  }
};

const actions = {
  loadList({ commit, state }, params) {
    var path =
      "volunteer" +
      (typeof params !== "undefined" &&
      typeof params.event !== "undefined" &&
      params.event != null
        ? "/event/" + params.event
        : "");
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function (response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "volunteer/" + params.id;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addVolunteer", data);
      }
    });
  },

  upload(context, data) {
    var volunteer = { ...data.data };
    volunteer.event = data.event;
    var params = data.params;
    var path =
      typeof volunteer.id !== "undefined"
        ? "volunteer/" + volunteer.id + "/update"
        : "volunteer/add";
    return api.post(path, volunteer).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("addVolunteer", data);
        return data.id;
      }
    });
  },

  loadStatesVolunteer({ commit }, params) {
    return api.get("volunteer/states").then(function (response) {
      if (response.status) {
        return commit("setState", response.data);
      }
    });
  },

  remove(context, params) {
    var path = "volunteer/" + params.id;
    if (params.event) path += "event/" + params.event;
    path += "/remove";
    return api.post(path, {}).then(function (response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removeVolunteer", id);
      }
    });
  },

  addRelVolunteerEvent(context, params) {
    return api
      .post(
        "volunteer/" +
          params.volunteer_id +
          "/event/" +
          params.event_id +
          "/addrel",
        {}
      )
      .then(function (response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  },

  changeStatus(context, params) {
    return api
      .post("volunteer/" + params.id + "/update/status", {
        event_id: params.event_id,
        status: params.status,
      })
      .then(function (response) {
        if (response.status) {
          var data = response.data;
          data.list_visible = true;

          context.commit("addVolunteer", data);
        }
      });
  },

  loadVolunteerDocuments({ commit }, params) {
    var path = "volunteer/documents/" + params.id + "/event/" + params.event;
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        return data;
      }
    });
  },

  changeVolunteerDocumentStatus(context, data) {
    return api
      .post(
        "volunteer/" + data.id + "/event/" + data.event + "/document/status",
        { key: data.key, status: data.status, url: data.url }
      )
      .then(function (response) {
        if (response.status) {
          return true;
        }
      });
  },

  rejectVolunteerDocument(context, data) {
    return api
      .post(
        "volunteer/" + data.id + "/event/" + data.event + "/document/reject",
        {
          key: data.key,
          reject: data.reject,
        }
      )
      .then(function (response) {
        if (response.status) {
          return true;
        }
      });
  },

  loadRelVolunteerEvent: ({ commit }, params) => {
    return api
      .get(
        "volunteer/" + params.person_id + "/event/" + params.event_id + "/get"
      )
      .then(function (response) {
        if (response.status) {
          return response.data;
        }
      });
  },

  fetchVolunteerRelEventEntity({ commit }, params) {
    var path = "volunteer/" + params.id + "/event/" + params.event + "/entity-events";
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data;
        commit("setRelEventEntityList", { data });
        return data;
      }
    });
  },

  assign_volunteer_to_team({ commit }, data) {
    const path = "volunteer/addEntityEvent";
    return api.post(path, data).then((response) => {
      return response;
    });
  },

  delete_volunteer_team_assignment({ commit }, data) {
    const path = "volunteer/deleteEntityEvent";
    return api.post(path, data).then((response) => {
      if (response.status) {
        return response;
      }
    });
  },

  loadEventConfirmedList({ commit, state }, params) {
    var path = "volunteer/event/" + params.event;
    var oParams = {
      status: 16
    }

    return api.post(path, oParams).then(function (response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setEventConfirmedList", data);
      }
    });
  }
};
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  setEventConfirmedList(state, data) {
    state.event_confirmed_list = data;
  },

  setState(state, data) {
    state.states_volunteer = data;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeVolunteer(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  addVolunteer(state, volunteer) {
    var list = { ...state.list };
    list[volunteer.id] = volunteer;
    state.list = list;
  },

  applyFilters(state, filters) {
    // var list = {...state.list};
    // if( !filters ){
    //     for( var i in list ){
    //         list[ i ].visible = true;
    //     }
    // }
    // else {
    //     for( var i in list ){
    //         list[ i ].visible = false;
    //     }
    //     for( var i in list ){
    //         var item = list[ i ];
    //         var bFound = true;
    //         var bEventFound = typeof filters['event'] === 'undefined';
    //         for( var k in filters ){

    //             if( filters[k] != -1 ){
    //                 var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
    //                 if( item.hasOwnProperty( k ) && filters[k] == null && item_value == null ){

    //                 } else {

    //                     if( filters[k] != null && typeof filters[k] === 'boolean' ) filters[k] = filters[k] ? 1 : 0
    //                     else if( filters[k] != null && typeof filters[k] === 'string' ) filters[k] = filters[k].trim()

    //                     var regexp = new RegExp( filters[k], "gi" );

    //                     if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
    //                     bFound = false;
    //                     }
    //                     else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
    //                         bFound = false;
    //                     }

    //                     if( k == 'event' && item.event != null ){
    //                         item.event.forEach( event => {
    //                         if( event.id[0] == filters[k] ){
    //                                 bFound = true;
    //                             }
    //                         })
    //                     } else if (filters[k] == 1){
    //                         bFound = true;
    //                     }

    //                     if( k == 'idiomas' && item.idiomas != null ){
    //                         typeof item.idiomas === 'string' ? item.idiomas=JSON.parse(item.idiomas.split(',')[0]+',"level":"Alt"}]'):true;
    //                         item.idiomas.forEach( lang => {
    //                         if( lang.lang == filters[k] ){
    //                                 bFound = true;
    //                             }
    //                         })
    //                     } else if (filters[k] == 1){
    //                         bFound = true;
    //                     }
    //                 }
    //             }
    //             list[ i ].visible = bFound;
    //         }
    //     }
    // }

    // state.list = list;
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setRelEventEntityList(state, { data }) {
    state.rel_event_entity_list = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
